// extracted by mini-css-extract-plugin
export default {"specCard":"styles_specCard__HrX1-","specCard__value":"styles_specCard__value__GiYTU","specCard__spec":"styles_specCard__spec__7BJuB"};